import { Avatar, message } from "antd";
import { UserOutlined } from "@ant-design/icons";
import {
  AccountAction,
  AvatarProfile,
  MailIds,
  ProfileWrapper,
  UserDetails,
  Wrapper,
} from "components/UserProfile/UserProfile.style";
import Images from "config/images";
import { Heading6 } from "config/global.style";
import SettingIcon from "components/Icons/SettingIcon";
import LogoutIcon from "components/Icons/LogoutIcon";
import { useAuth0 } from "@auth0/auth0-react";
import { useAppDispatch } from "redux/hooks";
import { clearCommonSlice, setTab } from "redux/slice/commanSlice";
import { useMemo, useState } from "react";
import { clearSlice } from "redux/slice/faxSlice";
import { Button } from "components/ui-component";
import { ConfirmationModal } from "components/ui-component/modals";
import { useLocation, useNavigate } from "react-router-dom";
import SelectNumber from "components/layouts/SelectNumber";
import useIsMobile from "hooks/useIsMobile";
import { backendLogout } from "API/backendLogout";

const UserProfile = () => {
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState(false);

  const { user, logout } = useAuth0();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const pathName = location.pathname;
  const isMobile = useIsMobile();

  const toggleModal = () => setIsLogoutModalVisible((prev) => !prev);

  const handleLogout = async () => {
    await backendLogout();
    logout();
    localStorage.clear();
    message.success("Sign out successfully");
    toggleModal();
    dispatch(clearSlice());
    dispatch(clearCommonSlice());
  };

  const isNotMainRoute = useMemo(() => pathName !== "/", [pathName]);

  return (
    <>
      <Wrapper>
        <ProfileWrapper>
          <AvatarProfile>
            <Avatar
              size="large"
              icon={<UserOutlined />}
              shape="circle"
              src={user?.picture ?? Images.profile}
            />
            <UserDetails>
              <Heading6 className="heading6">{user?.name}</Heading6>
              <MailIds>
                <span className="usermail">{user?.email}</span>
              </MailIds>
            </UserDetails>
          </AvatarProfile>
        </ProfileWrapper>
        <AccountAction>
          <ul>
            {isMobile && (
              <div className="mobile-template">
                <SelectNumber />
              </div>
            )}
            <li>
              <Button
                className="ctalinks"
                type="text"
                onClick={() => {
                  if (isNotMainRoute) {
                    navigate("/");
                  }
                  dispatch(setTab("settings"));
                }}
              >
                <SettingIcon />
                <span>Settings</span>
              </Button>
            </li>
            <li>
              <Button
                icon={<LogoutIcon />}
                type="text"
                className="ctalinks linkdanger"
                size="small"
                onClick={toggleModal}
              >
                Logout
              </Button>
            </li>
          </ul>
        </AccountAction>
      </Wrapper>
      <ConfirmationModal
        title="Are you sure you want to sign out?"
        open={isLogoutModalVisible}
        onConfirm={handleLogout}
        onCancel={toggleModal}
      />
    </>
  );
};

export default UserProfile;
